import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Typography } from "@mui/material"
import React from "react"

export interface ConfirmActionDialogProps {
  isOpen: boolean;
  title: string;
  children: React.ReactNode;
  onClose: () => void;
  onConfirm: () => void;
}

export const ConfirmActionDialog: React.FC<ConfirmActionDialogProps> = ({
  isOpen,
  title,
  children,
  onClose,
  onConfirm
}) => {
  return <Dialog open={isOpen} onClose={onClose}>
    <DialogTitle>{title}</DialogTitle>
    <DialogContent>
      <DialogContentText>{children}</DialogContentText>
    </DialogContent>
    <DialogActions>
      <Button onClick={onClose}
        variant="outlined"
        sx={{ margin: "0 8px", border: "1px solid #162C1F", borderRadius: "24px" }}
      >
        <Typography variant="button" component="h1" sx={{ color: "#162C1F" }}>
          Cancel
        </Typography>

      </Button>
      <Button
        onClick={() => { onConfirm(); onClose(); }}
        variant="contained"
        sx={{ margin: "0 8px", background: "#162C1F", border: "1px solid #162C1F", borderRadius: "24px" }}
        autoFocus>
        Remove
      </Button>
    </DialogActions>
  </Dialog>
}